module.exports = __webpack_public_path__ + "img/ada.ed119abe.png";